export default __webpack_public_path__ + "static/media/plus-outline-gray.185e6992.svg";